import data from './nimLang_fra.json';
const LocaleConfig = {
  ...data,
}

export default LocaleConfig